import {ActionTypes} from "./types";

const INITIAL_STATE = {
  partnerSetting: undefined,
};

const partnerSettingReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ActionTypes.SET_PARTNER_SETTING:
      return {
        ...state,
        partnerSetting: action.payload,
      };
    default:
      return state;
  }
};

export default partnerSettingReducer;